import React from 'react';
import {connect} from 'react-redux';
import {defineMessages, FormattedMessage} from 'react-intl';

import * as BetType from 'constants/BetType';

import * as BetStatuses from 'constants/BetStatus';
import * as StakeStatuses from 'constants/StakeStatus';

const messages = defineMessages({
    single: {
        id: 'bet_type.ordinar',
        defaultMessage: 'Ординар'
    },
    express: {
        id: 'bet_type.accumulator',
        defaultMessage: 'Экспресс'
    },
    antiexpress: {
        id: 'bet_type.looseToWinAccumulator',
        defaultMessage: 'Антиэкспресс'
    },
    system: {
        id: 'bet_type.system',
        defaultMessage: 'Система {rank} из {count}'
    }
});

class BetOverallInfo extends React.Component {
    static propTypes = {
        bet: React.PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
    }

    render() {
        const bet = this.props.bet;
        const betType = bet.get('betType');
        const rank = bet.get('rank');
        const count = bet.get('betSlips').size;
        const betStatus = bet.get('betStatus');
        const stakeStatus = bet.get('stakeStatus');
        const odd = bet.get('odd');
        const amount = bet.get('amount');
        const possibleWinAmount = bet.get('possibleWinAmount');

        let betTypeStr;
        switch (betType) {
            case BetType.SINGLE:
                betTypeStr = (<FormattedMessage {...messages.single} />);
                break;
            case BetType.EXPRESS:
                betTypeStr = (<FormattedMessage {...messages.express} />);
                break;
            case BetType.ANTIEXPRESS:
                betTypeStr = (<FormattedMessage {...messages.antiexpress} />);
                break;
            case BetType.SYSTEM:
                betTypeStr = (<FormattedMessage {...messages.system} values={{rank, count}} />);
                break;
        }

        switch (betStatus) {
            case BetStatuses.INIT:
            case BetStatuses.IN_DELAY:
            case BetStatuses.CONFIRM_AWAIT:
            case BetStatuses.CONFIRMED:
            case BetStatuses.STAKE_REQUEST:
            case BetStatuses.BET_PAY_REQUEST:
            case BetStatuses.CALCULATED:
                switch (stakeStatus) {
                    case StakeStatuses.ACTIVE:
                    case StakeStatuses.WON:
                        return (
                            <div className="bet-controls cf">
                                <div className="bet-type">
                                    {betTypeStr}
                                </div>
                                <div className="balance">
                                    <span>{amount}</span>
                                </div>
                                <div className="rate">
                                    <span>{odd}</span>
                                </div>

                                <div className="possible-win">
                                    <span>{possibleWinAmount}</span>
                                </div>
                            </div>
                        );
                    case StakeStatuses.LOST:
                        return (
                            <div className="bet-controls cf">
                                <div className="bet-type">
                                    {betTypeStr}
                                </div>
                                <div className="balance">
                                    <span>{amount}</span>
                                </div>
                                <div className="rate">
                                    <span>{odd}</span>
                                </div>
                            </div>
                        );
                }
                break;

            case BetStatuses.CASHOUT: {
                const cashout = bet.get('cashout');

                let cashoutAmount = bet.get('possibleWinAmount');
                if (cashout) {
                    cashoutAmount = cashout.get('amount');
                }

                return (
                    <div className="bet-controls cf">
                        <div className="bet-type">
                            {betTypeStr}
                        </div>
                        <div className="balance">
                            <span>{amount}</span>
                        </div>
                        <div className="rate">
                            <span>{odd}</span>
                        </div>
                        <div className="possible-win">
                            <span>{cashoutAmount}</span>
                        </div>
                    </div>
                );
            }

            case BetStatuses.REJECTED:
                return (
                    <div className="bet-controls cf">
                        <div className="bet-type">
                            {betTypeStr}
                        </div>
                        <div className="balance">
                            <span>{amount}</span>
                        </div>
                        <div className="rate">
                            <span>{odd}</span>
                        </div>
                    </div>
                );
        }

        return false;
    }
}

function select(state, props) {
    const id = props.id;
    const bet = state.application.getIn(['betHistory', id]);
    const languageId = state.application.get('languageId');

    return {
        bet,
        languageId
    };
}

export default connect(select)(BetOverallInfo);



// WEBPACK FOOTER //
// ./js/sport-betting/components/bet-panel-control/bet-history/BetOverallInfo.jsx